export default {
	editEventDate: "Edit entry or exit date",
	becomeMedium: "Become Medium",
	leaveMedium: "Leave Medium",
	becomeMediumTitle: "Become Medium",
	leaveMediumTitle: "Leave the Corrente",
	becomeMediumConfirm: "Confirm entry into the corrente",
	leaveMediumConfirm: "Confirm exit from the corrente",
	entryEvent: "Entry into the Corrente",
	exitEvent: "Exit from the Corrente",
	date: "Date",
	reason: "Reason",
	notes: "Notes",
	entryDate: "Date of entry into the corrente",
	entryNotes: "Entry notes",
	personSource: {
		existing: "Already registered",
		new: "Register new",
	},
	reasons: {
		voluntary: "Voluntary leave",
		disciplinary: "Disciplinary leave",
		transfer: "Transferred to another temple",
		other: "Other",
	},
	leaveMediumWarning: "This action will also deactivate all active journey stages for this person.",
	success: {
		entry: "Person is now a medium in the corrente",
		exit: "Person removed from the corrente",
	},
	timeline: {
		title: "History",
		empty: "No records found",
		by: "by",
	},
};
